import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const OutdoorDinningIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "OutdoorDinningIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.1165 8.22021H20.3722C21.3691 8.22021 22.1801 7.40865 22.1801 6.41107C22.1801 5.41876 21.3775 4.61044 20.3878 4.60197C20.2445 4.15033 19.9865 3.74017 19.6328 3.41084C19.1183 2.93166 18.4476 2.66779 17.7443 2.66779C17.0411 2.66779 16.3704 2.93166 15.8559 3.41084C15.5022 3.74022 15.2442 4.15033 15.1009 4.60197C14.1112 4.61045 13.3086 5.41873 13.3086 6.41107C13.3086 7.40865 14.1196 8.22021 15.1165 8.22021ZM15.1165 5.7738C15.1964 5.7738 15.2746 5.7886 15.3489 5.81786C15.5218 5.88595 15.7168 5.86794 15.8744 5.76934C16.032 5.67075 16.1334 5.50321 16.1477 5.31785C16.2119 4.48894 16.9132 3.83964 17.7444 3.83964C18.5756 3.83964 19.2768 4.48894 19.341 5.31785C19.3554 5.50316 19.4568 5.6707 19.6143 5.76934C19.7719 5.86798 19.9669 5.88598 20.1399 5.81786C20.2142 5.7886 20.2924 5.7738 20.3722 5.7738C20.723 5.7738 21.0083 6.05966 21.0083 6.41107C21.0083 6.76248 20.7229 7.04834 20.3722 7.04834H15.1165C14.7658 7.04834 14.4805 6.76248 14.4805 6.41107C14.4805 6.05966 14.7658 5.7738 15.1165 5.7738Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5943 15.9598H20.4882V11.1199C20.4882 10.7963 20.2258 10.534 19.9022 10.534H4.45816C4.13457 10.534 3.87222 10.7963 3.87222 11.1199V15.9598H2.76612C2.44253 15.9598 2.18018 16.2221 2.18018 16.5457V20.1887C2.18018 20.5123 2.44252 20.7747 2.76612 20.7747H3.87222V21.646C3.87222 21.9696 4.13456 22.2319 4.45816 22.2319C4.78176 22.2319 5.0441 21.9696 5.0441 21.646V20.7747H19.3163V21.646C19.3163 21.9696 19.5786 22.2319 19.9022 22.2319C20.2258 22.2319 20.4882 21.9696 20.4882 21.646V20.7747H21.5943C21.9179 20.7747 22.1802 20.5123 22.1802 20.1887V16.5457C22.1802 16.2221 21.9179 15.9598 21.5943 15.9598ZM5.0441 15.9598V14.5794H19.3163V15.9598H5.0441ZM5.0441 11.7059H19.3163V13.4075H5.0441V11.7059ZM21.0083 19.6028H3.35206V17.1317H21.0083V19.6028Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default OutdoorDinningIcon;
